//import the Polymer library
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-repeat.js";
import "@polymer/iron-ajax";

import search_dark_grey from "images/icons/icon_search_dark_grey.svg";

import "../../shared/GeneralToast";

import "./FilterScientific.style"
import Alodokter from "../../../../utils/Alodokter";
import GeneralAnalytics from "../../../../analytics/GeneralAnalytics";


class FilterScientific extends PolymerElement {
  static get template() {
    return html `
        <style include="filter-scientific-style"></style>
        <iron-ajax
            auto
            url="/api/general/ecourses/scientific_fields"
            handle-as="json"
            on-response="_responseHandler"
            debounce-duration="300">
        </iron-ajax>

        <general-toast
          is-active="{{isShowToast}}"
          body="Maaf, Bidang Ilmu tidak ditemukan"
          color="red"
        ></general-toast>

        <div class="filter-scientific-container">
            <h2>Pilih Bidang Ilmu yang Diminati</h2>
            <hr>
            <input class="input-scientific" type="text" name="s" minlength="3" value="{{keyword::input}}" on-keyup="_filterScienticList" autocomplete="off" placeholder="Cari Bidang Anda" style="background-image:url([[iconSearchDarkGrey]])"/>
            <div class="scientific-list-container">
                <dom-repeat items="{{filteredScientific}}" as="scientificItem">
                    <template>
                        <div class="item-scientific-container">
                            <label>
                                  <input type="radio" id="scientific" value="{{scientificItem.id}}" name="scientific" on-click="_chooseSpeciality" checked="{{_isSelected(scientificItem)}}">
                                  {{scientificItem.alias}}
                            <label>
                        </div>
                    <template>
                </dom-repeat>
            </div>
        </div>
        `;
  }

  static get properties() {
    return {
      scientificList: {
        type: Array,
        value: [],
      },
      iconSearchDarkGrey: {
        type: String,
        value: search_dark_grey,
      },
      keyword: {
        type: String,
        value: "",
      },
      filteredScientific: {
        type: Array,
        value: [],
      },
      isShowToast: {
        type: Boolean,
        value: false,
      },
    }
  }

  ready() {
    super.ready();
  }

  _responseHandler(e) {
    const pilihSemua = { alias: "Semua Spesialisasi", id: "all" }
    const res = e.detail.response.data.field_list;
    const queryParams = new URLSearchParams(window.location.search);
    const speciality = queryParams.get('speciality');
    res.unshift(pilihSemua)
    this.scientificList = res;
    this.filteredScientific = res;

    const isEmptyScientificField = !res.some((item) => item.id == speciality);
    if (isEmptyScientificField && speciality) {
      window.addEventListener('load', function() {
        this.isShowToast = true;
        setTimeout(function() { 
          this.isShowToast = false;
          window.location = window.location.origin + "/ecourse";
        }, 5000);
      }.bind(this));
    }
  }

  _isSelected(scientificItem) {
    let queryParams = new URLSearchParams(window.location.search)
    let speciality = queryParams.get('speciality')
    if (speciality == scientificItem.id) {
      return true
    } else {
      if(speciality == null && scientificItem.id == "all") {
        return true
      } else {
        return false
      }
    }
  }

  _filterScienticList() {
    let inputUser = this.keyword.toLowerCase()
    let currentScientificList = this.scientificList

    var obj = [];
    if (inputUser != undefined || inputUser != null) {
      currentScientificList.forEach((scientificField) => {
        let scientificName = scientificField.alias.toLowerCase()
        if (scientificName.includes(inputUser)) {
          obj.push({
            id: scientificField.id,
            alias: scientificField.alias,
          })
        }
        return this.filteredScientific = obj
      })
    } else {
      return this.filteredScientific = this.scientificList
    }
  }

  _chooseSpeciality(e) {
    var selected_radio = e.target.value
    var queryParams = new URLSearchParams(window.location.search)
    let speciality = queryParams.get('speciality')

    if (selected_radio == speciality) {
      return
    }
    
    const filedName = e.model.scientificItem.alias;
    let scientificFieldName = "category: " + filedName;
    Alodokter.sendEventGA('e-course landing page', 'ecourse_category_button_clicked', scientificFieldName)
    queryParams.set("speciality", selected_radio);
    queryParams.set("page", 1);
    let newUrlParam = new URL(window.location.origin + "/ecourse" + "?" + queryParams.toString());
    let multipleParams = newUrlParam

    // GA4
    GeneralAnalytics.selectCategory(filedName, "ecourse")
    
    return window.location = multipleParams
  }
}
customElements.define("filter-scientific", FilterScientific);